module.exports = __webpack_public_path__ + "img/game_actived.a5fd767b.png";